<template>
  <div class="fractional-bar">
    <v-tooltip v-for="(fraction, index) in fractionalData" :key="index" top>
      <template #activator="{ on }">
        <div :style="{ width: fraction.percent + '%', background: fraction.color }" v-on="on" />
      </template>
      <span>{{ `${fraction.name}: ${fraction.value}` }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      require: true,
      default: () => [{
        value: 0,
        percent: 100,
        color: '#696969',
        name: this.$tc('no_data')
      }]
    },
    title: {
      type: String,
      require: true,
      default: 'Fractional Bar'
    }
  },
  computed: {
    fractionalData () {
      const sum = this.data.reduce((acc, obj) => acc + obj.value, 0)
      if (sum === 0) {
        return [{
          value: 0,
          percent: 100,
          color: '#696969',
          name: this.$tc('no_data')
        }]
      } else {
        return this.data
      }
    }
  }
}
</script>

<style>
.fractional-bar {
  display: flex;
  height: 10px;
  border-radius: 8px;
  overflow: hidden;
}

.fractional-bar div {
  height: 100%;
  transition: width 2s ease-in-out;
}
</style>
